export default {
  name: 'logo',
  data() {
    return {};
  }
};